import { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { coursesActions } from '../../redux/actions';
import { getSubjectsP100 } from '../../redux/api/subjects';

export const useCoursesData = () => {
    const dispatch = useDispatch();
    const courses = useSelector((state) => state.courses.courses);
    const repoId = useSelector((state) => state?.auth?.user?.repo_id);
    const [hasP100Courses, setHasP100Courses] = useState(false);
    const [coursesLoaded, setCoursesLoaded] = useState(false);

    useEffect(() => {
        const checkP100Courses = async () => {
            try {
                const coursesData = await getSubjectsP100(repoId);
                setHasP100Courses(coursesData?.enrollments?.length > 0);
            } catch (error) {
                setHasP100Courses(false);
            } finally {
                setCoursesLoaded(true);
            }
        };

        if (repoId && !coursesLoaded) {
            checkP100Courses();
        }
    }, [repoId, coursesLoaded]);

    useEffect(() => {
        if (courses === null) {
            dispatch(
                coursesActions.getCoursesRequest({
                    size: '100',
                    offset: '0',
                })
            );
        }
    }, [courses, dispatch]);

    const hasCanvasCourses = courses && courses.length > 0;

    return {
        hasP100Courses,
        hasCanvasCourses,
        coursesLoaded,
    };
};
